import styled from 'styled-components'

import { IconV2 } from '../../Icon'

const warningMainDarkToken = '#996600'

export const Inner = styled.span.attrs({ className: 'theme-tags-typography-bodyS-tableButton' })`
  color: inherit;
  display: block;
`

const Box = styled.button`
  cursor: pointer;
  outline: none;
  min-height: var(--theme-size-buttonsHeight-table);

  padding-left: calc(var(--theme-space-padding-tableButton-table) - var(--theme-borderWidth-strokeS));
  padding-right: calc(var(--theme-space-padding-tableButton-table) - var(--theme-borderWidth-strokeS));

  border-style: solid;
  border-width: var(--theme-borderWidth-strokeS);
  border-radius: var(--theme-borderRadius-default);
  border-color: var(--theme-colors-global-general-transparent);

  transition:
    background 0.15s,
    color 0.15s,
    border 0.15s;
`

const IconBox = styled.button`
  cursor: pointer;
  outline: none;

  padding: 3px;

  border-style: solid;
  border-width: var(--theme-borderWidth-strokeS);
  border-radius: var(--theme-borderRadius-default);
  border-color: var(--theme-colors-global-general-transparent);

  transition:
    background 0.15s,
    color 0.15s,
    border 0.15s;
`

export const Positive = styled(Box)`
  background-color: var(--theme-colors-theme-brand-transparent-opacity12);

  color: var(--theme-colors-theme-positive-darkest);

  &:focus-visible {
    background-color: var(--theme-colors-theme-brand-transparent-opacity12);
    border-color: var(--theme-colors-theme-brand-darker);
  }

  &:hover {
    background-color: var(--theme-colors-theme-brand-transparent-opacity60);
  }

  &:active {
    background-color: var(--theme-colors-theme-brand-transparent-opacity12);
  }
`

export const Warning = styled(Box)`
  background-color: var(--theme-colors-theme-warning-transparent-opacity12);

  color: ${warningMainDarkToken};

  &:focus-visible {
    background-color: var(--theme-colors-theme-warning-transparent-opacity12);
    border-color: ${warningMainDarkToken};
  }

  &:hover {
    background-color: var(--theme-colors-theme-warning-transparent-opacity60);
  }

  &:active {
    background-color: var(--theme-colors-theme-warning-transparent-opacity12);
  }
`

export const Dander = styled(Box)`
  background-color: var(--theme-colors-theme-negative-transparent-opacity12);

  color: var(--theme-colors-theme-negative-darker);

  &:focus-visible {
    background-color: var(--theme-colors-theme-negative-transparent-opacity12);
    border-color: var(--theme-colors-theme-negative-darker);
  }

  &:hover {
    background-color: var(--theme-colors-theme-negative-transparent-opacity60);
  }

  &:active {
    background-color: var(--theme-colors-theme-negative-transparent-opacity12);
  }
`

export const Neutral = styled(Box)`
  background-color: var(--theme-colors-global-grey-grey100);

  color: var(--theme-colors-global-grey-grey900);

  &:focus-visible {
    background-color: var(--theme-colors-global-grey-grey100);
    border-color: var(--theme-colors-global-grey-grey900);
  }

  &:hover {
    background-color: var(--theme-colors-global-grey-grey300);
  }

  &:active {
    background-color: var(--theme-colors-global-grey-grey100);
  }
`

export const IconWrapper = styled(IconV2)`
  display: block;
`

export const Edit = styled(IconBox)`
  background-color: var(--theme-colors-global-general-transparent);

  color: var(--theme-colors-global-grey-grey900);

  &:focus-visible {
    background-color: var(--theme-colors-theme-brand-transparent-opacity12);
    color: var(--theme-colors-theme-brand-darker);
    border-color: var(--theme-colors-theme-brand-darker);
  }

  &:hover {
    background-color: #00c6983d;
    color: var(--theme-colors-theme-brand-darker);
  }

  &:active {
    background-color: var(--theme-colors-theme-brand-transparent-opacity12);
    color: var(--theme-colors-theme-brand-darker);
  }
`

export const Delete = styled(IconBox)`
  background-color: var(--theme-colors-global-general-transparent);

  color: var(--theme-colors-global-grey-grey900);

  &:focus-visible {
    background-color: var(--theme-colors-theme-negative-transparent-opacity12);
    color: var(--theme-colors-theme-negative-darker);
    border-color: var(--theme-colors-theme-negative-darker);
  }

  &:hover {
    background-color: var(--theme-colors-theme-negative-transparent-opacity12);
    color: var(--theme-colors-theme-negative-darker);
  }

  &:active {
    background-color: var(--theme-colors-theme-negative-transparent-opacity24);
    color: var(--theme-colors-theme-negative-darker);
  }
`
